import React, { FC, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SCP } from 'ia-react-core/~/interfaces/SCP';

import {
  StyledChevron,
} from './Chevron.styles';

export interface ChevronProps extends SCP<'svg'> {
  /** Styles the chevron as disabled. */
  disabled?: boolean;
  /** Indicates if the chevron is in the "opened" position. */
  isOpened?: boolean;
  /** Styles the color of the chevron. */
  color?: string;
  /** Marks the chevron as valid. */
  isValid?: boolean;
  /** Marks the chevron as touched. */
  isTouched?: boolean;
}

const ChevronDefaultProps = {};

// eslint-disable-next-line react/prop-types
const ChevronIcon: FC<ChevronProps> = ({ isValid, isOpened, isTouched, disabled, color, ...props }) => {
  const theme = useContext(ThemeContext);
  if (isOpened) {
    return <theme.icons.chevronUp {...props} />;
  }

  return <theme.icons.chevronDown {...props} />;
};

const Chevron: FC<ChevronProps> = ({ isOpened, disabled, isValid, color, ...props }) => (
  <StyledChevron
    role="presentation"
    focusable="false"
    as={ChevronIcon}
    disabled={disabled}
    isOpened={isOpened}
    isValid={isValid}
    color={color}
    {...props}
  />
);

Chevron.defaultProps = ChevronDefaultProps;

export default Chevron;
